import { render } from "./OrganizationItemCreateAndEdit.vue?vue&type=template&id=417d00f4&scoped=true"
import script from "./OrganizationItemCreateAndEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationItemCreateAndEdit.vue?vue&type=script&lang=js"

import "./OrganizationItemCreateAndEdit.vue?vue&type=style&index=0&id=417d00f4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417d00f4"]])

export default __exports__